import { Component, ElementRef, OnInit, Renderer2 } from '@angular/core';
import { DashboardService } from '@teem/services/dashboard.service';
import { dashboard as DashboardApi } from "@teem/constants/api";
import Swal from 'sweetalert2';
import { messages as i18n } from '@teem/constants/messages';
@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.scss']
})
export class PaymentHistoryComponent implements OnInit {
  isMenuUpwards = false;
  paymentsHistory = [];
  selectedCheckboxIds = [];
  selectAllPaymentHistory: boolean = false;

  constructor(private dashboardService: DashboardService,private renderer: Renderer2, private el: ElementRef) {
    document.addEventListener('click', (event: Event) => {
      this.paymentsHistory.forEach((r) => (r.menuVisible = false));
  
      const targetElement = event.target as HTMLElement;
      
      if (!targetElement.closest('.dots_container-rounded')) {
        this.paymentsHistory.forEach((r) => (r.menuVisible = false));
  
        const optionsMenus = this.el.nativeElement.querySelectorAll('.options-menu');
        optionsMenus.forEach((menu: HTMLElement) => {
          this.renderer.addClass(menu, 'd-none');
        });
      }
    });
   }

  ngOnInit(): void {
    this.getPaymentHistories();
  }

  toggleAllSelections(payments: any[], selectAllVar: string) {
		this[selectAllVar] = !this[selectAllVar];
		payments.forEach(payment => payment.selected = this[selectAllVar]);
	}

  getPaymentHistories() {
		this.dashboardService.getPaymentHistory().subscribe((response: any = []) => {
			this.paymentsHistory = response;
		});
	}

  toggleMenu(event: MouseEvent, row: any, index: number): void {
    event.stopPropagation();
    this.paymentsHistory.forEach((r) => (r.menuVisible = false));
    row.menuVisible = !row.menuVisible;

    const totalRows = this.paymentsHistory.length;
    this.isMenuUpwards = index >= totalRows - 2;
  }

  toggleSelection(payments: any[], selectAllVar: string) {
		this[selectAllVar] = payments.every(payment => payment.selected);
	}

  toggleDropdown(event: Event): void {
    const button = event.target as HTMLElement;
    const dropdownContainer = button.closest('.custom_select');
    const dropdownMenu = dropdownContainer.querySelector('.custom_select-content');
    const allDropdowns = document.querySelectorAll('.custom_select-content');
    const allContainers = document.querySelectorAll('.custom_select');
    
    allDropdowns.forEach((dropdown) => {
      if (dropdown !== dropdownMenu) {
        this.renderer.setStyle(dropdown, 'display', 'none');
      }
    });
  
    allContainers.forEach((container) => {
      if (container !== dropdownContainer) {
        this.renderer.removeClass(container, 'active');
      }
    });

    const isDropdownVisible = dropdownMenu.getAttribute('style') === 'display: block;';

    this.renderer.setStyle(dropdownMenu, 'display', isDropdownVisible ? 'none' : 'block');

    if (isDropdownVisible) {
      this.renderer.removeClass(dropdownContainer, 'active');
    } else {
      this.renderer.addClass(dropdownContainer, 'active');
    }
  }

  onCheckChange(event: any, checkboxId: string) {
      if (event.target.checked) {
        // Add the checkbox ID to the array if checked
        this.selectedCheckboxIds.push(checkboxId);
      } else {
        // Remove the checkbox ID from the array if unchecked
        const index = this.selectedCheckboxIds.indexOf(checkboxId);
        if (index > -1) {
          this.selectedCheckboxIds.splice(index, 1);
        }
      }
      console.log(this.selectedCheckboxIds);
    }
  
    downloadExcel() {
      // Convert the selected checkbox IDs into a query parameter
      const queryParams = this.selectedCheckboxIds.join(',');
  
      // Create the URL with query parameters
      const url = `${DashboardApi.downloadPaymentExcel}?ids=${queryParams}`;
  
      if ([...queryParams].length === 0) {
        Swal.fire({
          title: i18n.please_select_record_to_download,
          icon: 'info',
        })
      } else {
        window.open(url, '_blank');
      }
    }
  
    selectAll(event: any) {
      if (event.target.checked) {
        this.paymentsHistory.forEach(key => {
          if (!this.selectedCheckboxIds.includes(key.id)) {
            this.selectedCheckboxIds.push(key.id);
          }
        });
      } else {
        this.selectedCheckboxIds = []
      }
    }
  
    downloadPDF() {
      // Convert the selected checkbox IDs into a query parameter
      const queryParams = this.selectedCheckboxIds.join(',');
  
      // Create the URL with query parameters
      const url = `${DashboardApi.downloadPaymentPDF}?ids=${queryParams}`;
  
      if ([...queryParams].length === 0) {
        Swal.fire({
            title: i18n.please_select_record_to_download,
            icon: 'info',
          })
      } else {
        window.open(url, '_blank');
      }
    }

    transStatus(status : string) {
      return i18n.t(status.toLowerCase());
    }
}
